import React, { forwardRef } from 'react';

// Define the props for the Button component.
// It extends all standard HTML button attributes and adds children.
interface UnstyledButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	children: React.ReactNode;
}

const UnstyledButton = forwardRef<HTMLButtonElement, UnstyledButtonProps>(
	({ children, className = '', ...rest }, ref) => {
		return (
			<button ref={ref} className={`${className} fh-unstyled-button`} {...rest}>
				{children}
			</button>
		);
	},
);

UnstyledButton.displayName = 'UnstyledButton';

export default UnstyledButton;
